import React,{useEffect, useState} from 'react';
import { Table } from 'react-bootstrap';

export default function SearchTableView(props) {
    const {searchResult, handleShow, setSearchResult, searchCounter} = props;
    const [sorting, setSorting]=useState({field:"BookTitle",order:"asc"});

    // Reset to default listing whenever new search results arrive.
    // Default order: Author (asc) -> Title (asc) -> Accession (asc)
    const prevOrderRef = React.useRef('');
    useEffect(() => {
      if (!searchResult || searchResult.length === 0) return;
      const arr = (searchResult || []).slice();
      const sorted = arr.slice().sort((a, b) => {
        const aAuthor = (a.Book_Author || a.bookAuthor || '')?.toString();
        const bAuthor = (b.Book_Author || b.bookAuthor || '')?.toString();
        const authorCmp = aAuthor.localeCompare(bAuthor, undefined, {numeric: true, sensitivity: 'base'});
        if (authorCmp !== 0) return authorCmp;
        const aTitle = (a.Book_Title || a.bookTitle || '')?.toString();
        const bTitle = (b.Book_Title || b.bookTitle || '')?.toString();
        const titleCmp = aTitle.localeCompare(bTitle, undefined, {numeric: true, sensitivity: 'base'});
        if (titleCmp !== 0) return titleCmp;
        const aAcc = (a.Accession_No || a.accessionNo || '')?.toString();
        const bAcc = (b.Accession_No || b.accessionNo || '')?.toString();
        return aAcc.localeCompare(bAcc, undefined, {numeric: true, sensitivity: 'base'});
      });
      const newOrder = sorted.map(x => (x.Accession_No || x.accessionNo || '')?.toString()).join('|');
      if (prevOrderRef.current !== newOrder) {
        prevOrderRef.current = newOrder;
        setSearchResult(sorted);
      }
      setSorting({ field: 'BookAuthor', order: 'asc' });
    }, [searchResult]);

    // Reset sorting state whenever a new search is executed
    useEffect(() => {
      if (typeof searchCounter === 'undefined') return;
      setSorting({ field: 'BookAuthor', order: 'asc' });
      prevOrderRef.current = '';
    }, [searchCounter]);

    const handleSortKey = async (event, value, order) => {
      const fieldMap = {
        AccessionNo: 'Accession_No',
        BookTitle: 'Book_Title',
        BookAuthor: 'Book_Author',
        CallNo: 'Book_Classification_No',
      };
      const key = fieldMap[value];
      if (!key) return;
      const arr = (searchResult || []).slice();
      const sorted = arr.sort((a, b) => {
        const va = (a[key] || a[key.toLowerCase()] || '')?.toString();
        const vb = (b[key] || b[key.toLowerCase()] || '')?.toString();
        const cmp = va.localeCompare(vb, undefined, {numeric: true, sensitivity: 'base'});
        return order === 'asc' ? cmp : -cmp;
      });
      await setSearchResult(sorted);
      setSorting({ field: value, order });
    };

  return (
    <div className="p-2 p-md-4">
      {searchResult.length > 0 ? (
        <div className="card shadow-lg border-0" style={{borderRadius: 18, overflow: 'hidden', background: '#fff'}}>
          <div className="table-responsive">
            <Table hover responsive style={{marginBottom: 0, fontSize: '0.97rem'}}>
              <thead style={{background: 'linear-gradient(90deg, #e3f6fc 0%, #7ee8fa 100%)', position: 'sticky', top: 0, zIndex: 1}}>
                <tr style={{fontWeight: 700, color: '#063547', fontSize: '1.08rem'}}>
                  <th style={{minWidth: 40}}>#</th>
                  <th style={{minWidth: 110}}>
                    Accession No
                    <span style={{marginLeft: 6, verticalAlign: 'middle'}}>
                      {sorting.field === "AccessionNo" && sorting.order === "asc" ? (
                        <i
                          className="fa fa-arrow-down sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "AccessionNo", "desc")}
                          title="Sort Descending"
                        ></i>
                      ) : (
                        <i
                          className="fa fa-arrow-up sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "AccessionNo", "asc")}
                          title="Sort Ascending"
                        ></i>
                      )}
                    </span>
                  </th>
                  <th style={{minWidth: 180}}>
                    Book Title
                    <span style={{marginLeft: 6, verticalAlign: 'middle'}}>
                      {sorting.field === "BookTitle" && sorting.order === "asc" ? (
                        <i
                          className="fa fa-arrow-down sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "BookTitle", "desc")}
                          title="Sort Descending"
                        ></i>
                      ) : (
                        <i
                          className="fa fa-arrow-up sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "BookTitle", "asc")}
                          title="Sort Ascending"
                        ></i>
                      )}
                    </span>
                  </th>
                  <th style={{minWidth: 120}}>
                    Author
                    <span style={{marginLeft: 6, verticalAlign: 'middle'}}>
                      {sorting.field === "BookAuthor" && sorting.order === "asc" ? (
                        <i
                          className="fa fa-arrow-down sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "BookAuthor", "desc")}
                          title="Sort Descending"
                        ></i>
                      ) : (
                        <i
                          className="fa fa-arrow-up sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "BookAuthor", "asc")}
                          title="Sort Ascending"
                        ></i>
                      )}
                    </span>
                  </th>
                  <th style={{minWidth: 90}}>
                    Call No
                    <span style={{marginLeft: 6, verticalAlign: 'middle'}}>
                      {sorting.field === "CallNo" && sorting.order === "asc" ? (
                        <i
                          className="fa fa-arrow-down sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "CallNo", "desc")}
                          title="Sort Descending"
                        ></i>
                      ) : (
                        <i
                          className="fa fa-arrow-up sort-icon"
                          aria-hidden="true"
                          style={{cursor: 'pointer', color: '#0bb6d7', fontSize: '1.08em', padding: '2px 6px', borderRadius: 6, transition: 'background 0.2s'}}
                          onClick={event => handleSortKey(event, "CallNo", "asc")}
                          title="Sort Ascending"
                        ></i>
                      )}
                    </span>
                  </th>
                  <th style={{minWidth: 80}}>Status</th>
                </tr>
              </thead>
              <tbody style={{fontSize: '0.93rem'}}>
                {searchResult.map((item, index) => (
                  <tr
                    key={index}
                    onClick={event => handleShow(event, item)}
                    style={{cursor: 'pointer', transition: 'background 0.15s'}}
                    className="align-middle"
                  >
                    <td style={{fontWeight: 500, color: '#0bb6d7'}}>{index + 1}</td>
                    <td>{item.Accession_No}</td>
                    <td style={{fontWeight: 600, color: '#063547'}}>{item.Book_Title}</td>
                    <td>{item.Book_Author}</td>
                    <td>{item.Book_Classification_No}{" "}{item.authorMark}</td>
                    <td>
                      <span className={`badge rounded-pill px-3 py-1 ${['Available','Active'].includes(item.Book_Status) ? 'bg-success' : item.Book_Status === 'Issued' ? 'bg-warning text-dark' : 'bg-secondary'}`}>{item.Book_Status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : null}
    </div>
  )
}
